import type { FunctionComponent } from "react";
import { AddBrandSliderMenuPartial } from "../../../../partials/admin/menus/brand/add-brand-slider-menu.admin.partials";

export const AddBrandSliderMenuAdminScreen: FunctionComponent = () => {
	return <AddBrandSliderMenuPartial />;
};
